module.exports = __webpack_public_path__ + "img/enlogo.47b55ebb.png";